import { ref, onMounted, onUnmounted } from 'vue'

export function useDeviceView() {
  const isDesktop = ref(false)
  const userPreference = ref(localStorage.getItem('preferredView') || 'auto')

  const updateDeviceType = () => {
    if (userPreference.value !== 'auto') {
      isDesktop.value = userPreference.value === 'desktop'
      return
    }
    isDesktop.value = window.innerWidth >= 1024
  }

  const setPreferredView = (view) => {
    userPreference.value = view
    localStorage.setItem('preferredView', view)
    updateDeviceType()
  }

  onMounted(() => {
    updateDeviceType()
    window.addEventListener('resize', updateDeviceType)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateDeviceType)
  })

  return {
    isDesktop,
    userPreference,
    setPreferredView
  }
}